module.exports = __webpack_public_path__ + "img/orange_075.2b61502a.png";